import { Panel } from "../components/ui";

export default function RacePage() {
  return (
    <div className="cb-page">
      <Panel className="hl center">
        <h2 className="cb-h">🏆 Server Race</h2>
        <p className="dim small" style={{ margin: 0 }}>No race is running right now.</p>
      </Panel>
      <Panel className="center">
        <p className="small" role="status" aria-live="polite">No standings yet. Race results will appear here once bakeries start competing.</p>
      </Panel>
    </div>
  );
}
